import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import type {DeleteMemexChartRequest} from './contracts/api'

export async function apiDestroyChart(body: DeleteMemexChartRequest): Promise<void> {
  const apiMetadata = getApiMetadata('memex-chart-delete-api-data')
  const {data} = await fetchJSON<DeleteMemexChartRequest, void>(apiMetadata.url, {
    method: 'DELETE',
    body,
    token: apiMetadata.token,
  })

  return data
}
